export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.2002a425.woff2";